// Opt-in, renderer-local evidence only: no audio/text content, storage, network,
// timers or console traffic. Sequence gaps/overwrites make a run inconclusive.
export const VOICE_TRACE_BUILD = 'aria-handoff-rc1';
export function createVoiceTrace({ capacity = 12000, now = () => performance.now(), wall = () => Date.now() } = {}) {
  const limit = Math.max(1, Math.floor(capacity) || 12000);
  let enabled = false;
  let rows = new Array(limit);
  let count = 0;
  let next = 0;
  let seq = 0;
  const fields = new Set(['id', 'owner', 'previousId', 'held', 'speaking', 'work', 'clips',
    'reason', 'session', 'generation', 'muted', 'floor', 'hasMic', 'frame', 'bytes',
    'route', 'buffered', 'chars', 'delayMs', 'label', 'loading']);
  const record = (event, data = {}) => {
    if (!enabled) return;
    try {
      const row = { seq: ++seq, ms: now(), utc: new Date(wall()).toISOString(), event: String(event).slice(0, 80) };
      for (const [key, value] of Object.entries(data)) {
        if (fields.has(key) && (value === null || ['number', 'boolean', 'string'].includes(typeof value))) {
          row[key] = typeof value === 'string' ? value.slice(0, 120) : value;
        }
      }
      rows[next] = row;
      next = (next + 1) % limit;
      count = Math.min(count + 1, limit);
    } catch (_) { /* Diagnostics must never affect voice control. */ }
  };
  const api = {
    build: VOICE_TRACE_BUILD,
    enabled: () => enabled,
    record,
    start() {
      rows = new Array(limit); count = 0; next = 0; seq = 0; enabled = true;
      record('trace.start');
    },
    stop() { record('trace.stop'); enabled = false; },
    mark(label) { record('operator.mark', { label }); },
    clear() { rows = new Array(limit); count = 0; next = 0; seq = 0; },
    export() {
      const events = Array.from({ length: count }, (_, i) => ({ ...rows[(next - count + i + limit) % limit] }));
      return { build: VOICE_TRACE_BUILD, enabled, capacity: limit, overwritten: Math.max(0, seq - count), events };
    },
  };
  return api;
}
export const voiceTrace = createVoiceTrace();
if (typeof window !== 'undefined') window.__ariaVoiceTrace = voiceTrace;
